import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getResidentialFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at apartment complexes and HOA communities?`,
    answer: `Food ${vehicleType}s visit your property on a scheduled basis and sell food directly to residents. ${siteTitle} curates and manages a rotating lineup of food ${vehicleType}s, handling scheduling, communication, and logistics. Trucks arrive fully self-contained, serve residents on-site, and leave with no cleanup required from your team.`
  },
  {
    question: `Does it cost apartment communities anything to host food ${vehicleType}s?`,
    answer: `In most cases, hosting food ${vehicleType}s is little to no cost for apartment communities or HOAs. Food ${vehicleType}s sell directly to residents, and there are no contracts or long-term commitments required. Optional resident incentives or credits can be added if you want to enhance engagement, but they're not required.`
  },
  {
    question: `How often can food ${vehicleType}s visit my apartment or neighborhood?`,
    answer: `Food ${vehicleType}s can be scheduled weekly, bi-weekly, monthly, or on a recurring rotation depending on your community's size and interest. Many properties choose a consistent schedule so residents know when food ${vehicleType}s will be on-site. Our platform adapts over time based on resident feedback and ordering patterns.`
  },
  {
    question: `Do residents need to pre-order food from the ${vehicleType}s?`,
    answer: `No. Residents can order directly at the ${vehicleType} when it arrives or place orders online to skip the line. Weekly menu emails and a custom web page make it easy for residents to see what food ${vehicleType}s are coming and plan ahead.`
  },
  {
    question: `What space or setup is required to host a food ${vehicleType}?`,
    answer: `Most properties only need a designated parking or loading area for the food ${vehicleType}. Trucks are fully self-sufficient and do not require access to kitchens or indoor space. If there are questions around access, power, or traffic flow, our team helps coordinate details with the vendors.`
  },
  {
    question: `Why are food ${vehicleType}s a good amenity for apartment communities?`,
    answer: `Food ${vehicleType}s create a fun, social experience that helps residents connect while adding value without major operational effort. They're a popular perk for work-from-home residents, improve community engagement, and help properties stand out to prospective renters—all while supporting local small businesses.`
  }
];

function ResidentialFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getResidentialFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default ResidentialFaq;
